import React from 'react'

export default ({PLACEHOLDER, ...props}) => (
    <svg width="201" height="69" viewBox="0 0 201 69" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.47949 64.944L61.4724 1.29688H200.655" stroke="white" strokeWidth="0.75" strokeMiterlimit="10"/>
        <path d="M3.62455 68.4235C5.62634 68.4235 7.24911 66.8007 7.24911 64.7989C7.24911 62.7971 5.62634 61.1744 3.62455 61.1744C1.62277 61.1744 0 62.7971 0 64.7989C0 66.8007 1.62277 68.4235 3.62455 68.4235Z" fill="white"/>
    </svg>
)
